const _temp0 = require("url:../friscos/friscos---behance_01.png");
const _temp1 = require("url:../friscos/friscos---behance_02.gif");
const _temp2 = require("url:../friscos/friscos---behance_03.gif");
const _temp3 = require("url:../friscos/friscos---behance_04.gif");
const _temp4 = require("url:../friscos/friscos---behance_05.gif");
const _temp5 = require("url:../friscos/friscos---behance_06.gif");
const _temp6 = require("url:../friscos/friscos---behance_07.gif");
const _temp7 = require("url:../friscos/friscos---behance_08.gif");
const _temp8 = require("url:../friscos/friscos---behance_09.gif");
const _temp9 = require("url:../friscos/friscos---behance_10.gif");
const _temp10 = require("url:../friscos/friscos---behance_11.gif");
const _temp11 = require("url:../friscos/friscos---behance_12.gif");
const _temp12 = require("url:../friscos/friscos---behance_13.gif");
const _temp13 = require("url:../friscos/friscos---behance_15.gif");
const _temp14 = require("url:../friscos/friscos-cover-img.png");

const _temp15 = require("url:../nike/nike-01.mp4");

const _temp16 = require("url:../parada/Parada-680-behance-_01.png");
const _temp17 = require("url:../parada/Parada-680-behance-_02.png");
const _temp18 = require("url:../parada/Parada-680-behance-_03.png");
const _temp19 = require("url:../parada/Parada-680-behance-_04.png");
const _temp20 = require("url:../parada/Parada-680-behance-_05.png");
const _temp21 = require("url:../parada/Parada-680-behance-_06.png");
const _temp22 = require("url:../parada/Parada-680-behance-_07.png");
const _temp23 = require("url:../parada/Parada-680-behance-_08.png");
const _temp24 = require("url:../parada/Parada-680-behance-_09.png");
const _temp25 = require("url:../parada/Parada-680-behance-_10.png");

const _temp26 = require("url:../wager/01.png");
const _temp27 = require("url:../wager/02.png");
const _temp28 = require("url:../wager/03.png");
const _temp29 = require("url:../wager/04.png");
const _temp30 = require("url:../wager/05.png");
const _temp31 = require("url:../wager/06.png");
const _temp32 = require("url:../wager/07.png");
const _temp33 = require("url:../wager/08.png");
const _temp34 = require("url:../wager/09.png");

module.exports = {
  "friscos":   {
    "friscos---behance_01.png": _temp0,
    "friscos---behance_02.gif": _temp1,
    "friscos---behance_03.gif": _temp2,
    "friscos---behance_04.gif": _temp3,
    "friscos---behance_05.gif": _temp4,
    "friscos---behance_06.gif": _temp5,
    "friscos---behance_07.gif": _temp6,
    "friscos---behance_08.gif": _temp7,
    "friscos---behance_09.gif": _temp8,
    "friscos---behance_10.gif": _temp9,
    "friscos---behance_11.gif": _temp10,
    "friscos---behance_12.gif": _temp11,
    "friscos---behance_13.gif": _temp12,
    "friscos---behance_15.gif": _temp13,
    "friscos-cover-img.png": _temp14
  },
  "nike":   {
    "nike-01.mp4": _temp15
  },
  "parada":   {
    "Parada-680-behance-_01.png": _temp16,
    "Parada-680-behance-_02.png": _temp17,
    "Parada-680-behance-_03.png": _temp18,
    "Parada-680-behance-_04.png": _temp19,
    "Parada-680-behance-_05.png": _temp20,
    "Parada-680-behance-_06.png": _temp21,
    "Parada-680-behance-_07.png": _temp22,
    "Parada-680-behance-_08.png": _temp23,
    "Parada-680-behance-_09.png": _temp24,
    "Parada-680-behance-_10.png": _temp25
  },
  "wager":   {
    "01.png": _temp26,
    "02.png": _temp27,
    "03.png": _temp28,
    "04.png": _temp29,
    "05.png": _temp30,
    "06.png": _temp31,
    "07.png": _temp32,
    "08.png": _temp33,
    "09.png": _temp34
  }
}